import CtaButton from 'components/AnnouncementCampaigns/CtaButton'
import useActiveAnnouncementCampaign from 'hooks/useActiveAnnouncementCampaign'
import { useActiveSenderIds } from 'hooks/useActiveSenderId'
import { clearActiveCampaign } from 'modules/campaigns/actions'
import { markAnnouncementPlaybookClicked } from 'modules/campaigns/announcements'
import { toggleChat } from 'modules/view/actions'
import React, { LegacyRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CTAType } from 'types/message'

import SenderInfo from '../SenderInfo'

import './style.css'

interface WelcomeMessageMessageProps {
  previewRef: LegacyRef<HTMLDivElement>
}

const WelcomeMessage = ({ previewRef }: WelcomeMessageMessageProps) => {
  const dispatch = useDispatch()
  const { chatOpen } = useSelector(state => (
    state.view
  ))

  const senderIds = useActiveSenderIds()
  const announcementCampaignData = useActiveAnnouncementCampaign()

  if (!chatOpen) { return null }

  const onCtaClicked = async () => {
    await markAnnouncementPlaybookClicked()
    dispatch(clearActiveCampaign())

    if(announcementCampaignData.ctaType === CTAType.LINK_TO_URL) {
      dispatch(toggleChat({ chatOpen: false }))
    }
  }

  return (
    <div className="drift-widget-greeting">
      <SenderInfo senderIds={senderIds}/>
      <div
      ref={previewRef}
      className="drift-widget-welcome-message-content"
      >
        <div
          dangerouslySetInnerHTML={{
            __html:`
              <div class="drift-welcome-message-content--body">
                ${announcementCampaignData.body}
              </div>
            `
          }}
        />
      </div>
      { announcementCampaignData.ctaCopy && announcementCampaignData.ctaType !== CTAType.CHAT_RESPONSE &&
        <div className="drift-widget-greeting-cta-wrapper">
          <CtaButton
            ctaUrl={announcementCampaignData.ctaUrl}
            ctaType={announcementCampaignData.ctaType}
            ctaCopy={announcementCampaignData.ctaCopy}
            onClick={onCtaClicked}
          />
        </div>
      }
    </div>
  )
}


export default WelcomeMessage
